<template>
  <div>
    <b-button size="sm" @click="ver = true" variant="success"><b-icon-search /></b-button>

    <b-modal @show="Limpiar" size="lg" title="Buscar Cliente" v-model="ver">
      <template #modal-header="{  }">
        <b-input-group prepend="Cliente">
          <b-form-input v-model="qr" autofocus placeholder="Buscar" />
        </b-input-group>
      </template>

      <div v-show="!selCliente.Nombre">
        <b-table-lite v-if="Clientes.length" small bordered table-variant="warning" hover @row-clicked="onRowClick" :items="Clientes" :fields="Campos"></b-table-lite>
        <b-alert variant="warning" v-else :show="true"> <b-icon-exclamation-circle-fill /> No hay información! </b-alert>
      </div>
      <div v-show="!!selCliente.Nombre">
        <b-input-group prepend="Nombre">
          <b-input autofocus v-model="selCliente.Nombre" :formatter="quitarAcentos"></b-input>
        </b-input-group>

        <b-input-group class="my-2" prepend="Celular">
          <b-input v-model="selCliente.Celular"></b-input>
        </b-input-group>

        <b-input-group class="my-2" prepend="Dirección">
          <b-input v-model="selCliente.Direccion"></b-input>
        </b-input-group>

        <b-input-group class="my-2" prepend="Deuda">
          <template #prepend> <b-input-group-text class="bg-success text-white"> Deuda</b-input-group-text> </template>
          <label v-html="deuda" class="form-control"></label>
        </b-input-group>
      </div>

      <template #modal-footer="{cancel}">
        <b-button-group>
          <b-button variant="primary" size="sm" @click="cancel()"> Cerrar </b-button>
          <b-button v-show="!!selCliente.Nombre" variant="success" size="sm" @click="Continuar"> Continuar </b-button>
        </b-button-group>
      </template>
    </b-modal>
  </div>
</template>
<script>
import firebase from "firebase/app";
import "firebase/firestore";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  firestore: {
    cliente: db.collection("Cliente"),
  },
  computed: {
    Actualiza(){
      let dif=0

    if(this.tmpCliente.Nombre != this.selCliente.Nombre) dif++;
    if(this.tmpCliente.Celular != this.selCliente.Celular) dif++;
    if(this.tmpCliente.Direccion != this.selCliente.Direccion) dif++;

      return dif>0
    },
    deuda() {
      let a = this.selCliente.Deuda ? this.selCliente.Deuda : 0.0;
      return a.toFixed(2);
    },
    Clientes() {
      if (this.qr.length > 1) {
        let qr = this.reg(this.qr);
        let txt = new RegExp(qr, "gmi");

        let datos = this.cliente
          .filter((r) => {
            return txt.test(r.Nombre);
          })
          .slice(0, 5)
          .map((r) => {
            return { ...r, id: r.id };
          });

        return datos;
      } else return [];
    },
  },

  methods: {
    Limpiar(){
      this.selCliente={};
    },
    quitarAcentos(cadena) {
      const acentos = { á: "a", é: "e", í: "i", ó: "o", ú: "u", Á: "A", É: "E", Í: "I", Ó: "O", Ú: "U" };
      let rs = cadena
        .split("")
        .map((letra) => acentos[letra] || letra)
        .join("")
        .toString();
      return rs.toUpperCase();
    },
    Continuar() {
      let c = { ...this.selCliente };

      if(this.Actualiza){
      let upd = { Nombre: c.Nombre, Celular: c.Celular, Direccion: c.Direccion };

      db.collection("Cliente")
        .doc(c.id)
        .update(upd)
        .then(() => {
          this.$emit("Respuesta", c);

          this.selCliente = {};
          this.ver = false;
        });}
        else {
          this.$emit("Respuesta", c);

          this.selCliente = {};
          this.ver = false;
        }

    },
    onRowClick(r) {
      let rs = { ...r };
      this.tmpCliente={...r};
      this.selCliente = rs;
    },
    reg(txt) {
      let r = "";
      txt.split(" ").forEach((p) => {
        r += "(?=.*" + p + ")";
      });
      return r + ".*";
    },
    ok() {
      this.Clientes();
      this.ver = false;
    },
    onClickButton() {
      this.$emit("Respuesta", "Info cliente");
    },
  },
  watch: {
    ver(v) {
      if (v == false) this.qr = "";
    },
  },
  data() {
    return {
      tmpCliente:{},
      selCliente: {},
      ver: false,
      tmp: null,
      cliente: [],
      qr: "",
      Campos: ["Nombre", "Region"],
    };
  },
};
</script>
